var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.errorMessage != null)?_c('v-alert',{attrs:{"value":true,"type":"error"}},[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e(),(_vm.loggedOut === true)?_c('PageIntro',{attrs:{"heading":'<span>' +
      _vm.configStrings.clubName +
      ' ' +
      _vm.configStrings.productName +
      '</span>',"body":'<p>You are now signed out of your ' +
      _vm.configStrings.clubName +
      ' ' +
      _vm.configStrings.productName +
      '.</p>'}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }